module.exports = __webpack_public_path__ + "img/DO.b8f8b827.png";